import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { siteContentService } from '../services/api';

function FAQ() {
  const [faqs, setFaqs] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await siteContentService.get('INFORMATION_FAQS');
        if (response.data && response.data.value) {
          const parsed = JSON.parse(response.data.value);
          if (Array.isArray(parsed) && parsed.length > 0) {
            setFaqs(parsed.map(f => ({ question: f.question, answer: f.answer })));
          }
        }
      } catch (error) {
        console.error('Error fetching FAQs:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchFaqs();
  }, []);

  if (loading) {
    return (
      <div className="bg-gray-50 min-h-screen">
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">در حال بارگذاری...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">سوالات متداول</h1>
          <p className="text-xl text-blue-100">پاسخ به سوالات رایج</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-white rounded-lg shadow-md overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full px-6 py-4 flex items-center justify-between hover:bg-blue-50 transition text-right"
              >
                <ChevronDown
                  size={20}
                  className={`text-blue-700 transition ${openIndex === idx ? 'rotate-180' : ''}`}
                />
                <h3 className="text-lg font-bold text-gray-900 flex-1 mr-4">{faq.question}</h3>
              </button>
              {openIndex === idx && (
                <div className="px-6 py-4 bg-blue-50 border-t border-gray-200">
                  <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FAQ;
